import { ComponentType, type IConfig } from '../../types';
import { ComponentConfigType } from '../../utils/data-parser';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
  BASIC_VARIABLE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.FormFlex,
  configGroups: [
    {
      title: 'Component Settings',
      items: [
        {
          name: 'vertical',
          label: 'Vertical',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'wrap',
          label: 'Wrap',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Wrap', value: 'wrap' },
              { label: 'No Wrap', value: 'nowrap' },
              { label: 'Wrap Reverse', value: 'wrap-reverse' },
            ],
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'justify',
          label: 'Justify',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Flex Start', value: 'flex-start' },
              { label: 'Flex End', value: 'flex-end' },
              { label: 'Center', value: 'center' },
              { label: 'Space Between', value: 'space-between' },
              { label: 'Space Around', value: 'space-around' },
              { label: 'Space Evenly', value: 'space-evenly' },
            ],
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'align',
          label: 'Align',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Flex Start', value: 'flex-start' },
              { label: 'Flex End', value: 'flex-end' },
              { label: 'Center', value: 'center' },
              { label: 'Stretch', value: 'stretch' },
              { label: 'Baseline', value: 'baseline' },
            ],
            defaultValue: 'flex-start',
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'gap',
          label: 'Gap',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Small', value: 'small' },
              { label: 'Middle', value: 'middle' },
              { label: 'Large', value: 'large' },
            ],
            defaultValue: undefined,
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
      ],
    },
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
